module.exports = __webpack_public_path__ + "static/media/copyBlack.aa6d474a.svg";